import { render, staticRenderFns } from "./SubscriptionDiscrepancy.vue?vue&type=template&id=4145e7cc&scoped=true&"
import script from "./SubscriptionDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDiscrepancy.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionDiscrepancy.vue?vue&type=style&index=0&id=4145e7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145e7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VChip,VContainer,VDataTable,VProgressLinear})
